import { html } from 'htm/preact';
import { useState, useEffect } from 'preact/hooks';

import Button from './Button';
import Header from './Header';
import Link from './Link';
import SectionDivider from './SectionDivider';

const StepNumberTransfer = ({ onTransfer, onReturn, customerId, instructions, portinError }) => {
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    console.log(portinError);
    if (portinError?.portIn === 'Failed') {
      if (portinError?.error?.error === 'INELIGIBLE_MSISDN') {
        setErrors({ portInMdn: "The phone number isn't eligible to transfer." });
      } else if (portinError?.error?.error) {
        setErrors({ custom: portinError.error.error });
      } else {
        setErrors({});
      }
    } else {
      setErrors(portinError);
    }
  }, [portinError]);

  const validateForm = (data) => {
    const formErrors = {};

    if (!data.portInMdn || data.portInMdn.length !== 10) {
      formErrors.portInMdn = 'Please enter a valid 10-digit phone number.';
    }

    if (!data.zipCode || data.zipCode.length !== 5) {
      formErrors.zipCode = 'Please enter a valid 5-digit ZIP code.';
    }

    return Object.keys(formErrors).length ? formErrors : null
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const formatedData = {
      CustomerId: customerId,
      zipCode: formData.get('zip'),
      portInMdn: formData.get('phoneNumber').replace(/\D/g, ''),
      ospAccountNumber: formData.get('accountNumber'),
      ospAccountPassword: formData.get('transferPin'),
      isNew: false,
      resubmit: !!portinError,
    };
  
    const errors = validateForm(formatedData);
    setErrors(errors);

    if (!errors) {
      onTransfer(formatedData);
    }
  };

  let description;
  if (errors) {
    if (errors.custom) {
      description = errors.custom;
    } else {
      description = 'There was an error with your submission. Please correct the errors and try again.';
    }
  } else {
    description = 'You\'ll need the current phone number, account number, Transfer PIN, and Billing ZIP code from your current carrier.';
  }

  return html`
    <${Header}
      title="Transfer Your Number"
      description=${description}
      isError=${!!errors}
    />
    <div class="flex flex-col lg:flex-row gap-6 lg:gap-12 mb-8">
      <div class="flex flex-col w-full lg:w-1/2">
        <h3 class="flex h4 mb-2">
          Follow ${instructions.title.includes('Other') ? 'these' : instructions.title} Instructions
        </h3>
        ${instructions.description.split('\n').map((line) => html`<p class="text-sm mb-2">${line}</p>`)}
      </div>
      <${SectionDivider} label="and" />
      <div class="flex flex-col w-full lg:w-1/2">
        <h3 class="h4 mb-3">Enter Your Account Info</h3>
        <form onSubmit=${handleSubmit} class="flex flex-col gap-3 items-stretch w-full">
          <fieldset class="flex flex-col">
            <label for="phoneNumber" class="text-xs mb-1"
              >Current Phone Number<span class="text-red-600">*</span></label
            >
            <input
              type="text"
              class="grow min-w-0 px-5 py-4 rounded-xl text-base lg:text-sm focus:outline-none"
              name="phoneNumber"
              placeholder="Current Phone Number"
              aria-label="Current Phone Number"
              required
            />
            ${errors?.portInMdn && html`<p class="text-red-500 text-xs mt-1">${errors.portInMdn}</p>`}
          </fieldset>
          <fieldset class="flex flex-col">
            <label for="accountNumber" class="text-xs mb-1">Account Number<span class="text-red-600">*</span></label>
            <input
              type="text"
              class="grow min-w-0 px-5 py-4 rounded-xl text-base lg:text-sm focus:outline-none"
              name="accountNumber"
              placeholder="Account Number"
              aria-label="Account Number"
              required
            />
            ${errors?.ospAccountNumber && html`<p class="text-red-500 text-xs mt-1">${errors.ospAccountNumber}</p>`}
          </fieldset>
          <fieldset class="flex flex-col">
            <label for="transferPin" class="text-xs mb-1">Transfer PIN<span class="text-red-600">*</span></label>
            <input
              type="text"
              class="grow min-w-0 px-5 py-4 rounded-xl text-base lg:text-sm focus:outline-none"
              name="transferPin"
              placeholder="Transfer PIN"
              aria-label="Transfer PIN"
              required
            />
            ${errors?.ospAccountPassword && html`<p class="text-red-500 text-xs mt-1">${errors.ospAccountPassword}</p>`}
          </fieldset>
          <fieldset class="flex flex-col">
            <label for="zip" class="text-xs mb-1">Billing ZIP Code<span class="text-red-600">*</span></label>
            <input
              type="text"
              class="grow min-w-0 px-5 py-4 rounded-xl text-base lg:text-sm focus:outline-none"
              name="zip"
              placeholder="Billing ZIP Code"
              aria-label="Billing ZIP Code"
              required
            />
            ${errors?.zipCode && html`<p class="text-red-500 text-xs mt-1">${errors.zipCode}</p>`}
          </fieldset>

          <div class="mt-2">
            <${Button} text="Start Transfer" />
          </div>
        </form>
      </div>
    </div>

    ${!errors && html`
      <div class="flex justify-center">
        <${Link} text="Back to the previous step" onClick=${onReturn} />
      </div>
    `}
  `;
};

export default StepNumberTransfer;
